// Логото на фирмата за менюто горе вляво. Не идва със списъка на фирмите
// (data URL — тежко е), затова се взима веднъж за фирма и се пази тук.
// Отделен модул, за да могат и менюто, и екранът „Мои фирми" да го ползват
// без кръгов import през shell.js.
import { api } from './api.js';

const cache = new Map();

// Връща логото (data URL) или '' — веднага от паметта, иначе от сървъра.
export function companyLogo(company) {
  const key = String(company.id);
  if (cache.has(key)) return Promise.resolve(cache.get(key));
  if (!company.logo_set) { cache.set(key, ''); return Promise.resolve(''); }
  return api('/companies/' + company.id + '/logo')
    .then((r) => { const v = (r && r.logo) || ''; cache.set(key, v); return v; })
    .catch(() => '');
}

// След качване или махане на лого — следващото рисуване го взима наново.
export function forgetCompanyLogo(id) { cache.delete(String(id)); }
